import { render, staticRenderFns } from "./ButtonCircle.vue?vue&type=template&id=6053f469&scoped=true"
import script from "./ButtonCircle.vue?vue&type=script&lang=ts"
export * from "./ButtonCircle.vue?vue&type=script&lang=ts"
import style0 from "./ButtonCircle.vue?vue&type=style&index=0&id=6053f469&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053f469",
  null
  
)

export default component.exports